import React from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row, FormText
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';
import InfoIcon from 'react-icons/lib/md/info';
import { appConstants } from '../../_constants';


const SearchPanel = ({ airlineValue, user, airlines, searchFlightNumbers, handleInputChange, flightDate,
    handleSelectChange, onSearch, changeDatePicker, airlineSelectNotification, componentErrorMessages,
    flightValue, depAirports, depValue, desAirports, desValue, tickets, ticketValue, status, statusValue }) => {

    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-4"}>
                            <Label>Flight Date</Label>
                            <DateSelector
                                maxDate={new Date()}
                                todayDate={(new Date()).toString()}
                                name="flightDate" 
                                onValueChange={(date) => changeDatePicker(date, 'flightDate')} />
                            {componentErrorMessages.flightDate && <FormText color="danger"> {componentErrorMessages.flightDate}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-4 "}>
                            <Label>Airline</Label>

                            {/* {(user.userRole === appConstants.ROLES.SUPER_ADMIN || appConstants.ROLES.VGG_ADMIN) ? */}
                            {(user.OrganizationType === appConstants.ORGANIZATIONS.OTHERS) ?

                            // <label>{(airlineValue)&& airlineValue.Name}</label>
                            <SelectListComponent
                            data={airlines}
                            valueKey="Id"
                            textField="Name"
                            disabled={true}
                            selectValue={ airlineValue&& airlineValue.Id}
                        />
                                :
                                <SelectListComponent
                                    onValueChange={(event) => {
                                        handleSelectChange(event, "airlineValue", true);
                                    }}
                                    data={airlines}
                                    valueKey="Id"
                                    textField="Name"
                                    selectValue={airlineValue}
                                />
                            }
                        {componentErrorMessages.airlineValue && <FormText color="danger"> {componentErrorMessages.airlineValue}</FormText>}
                        </FormGroup>
                    </Col>

                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-4 "}>
                            <Label>Flight Number</Label>{airlineSelectNotification && <small style={{ color: "#d50000" }}><InfoIcon size="15" />{airlineSelectNotification}</small>}
                            <SelectListComponent
                                data={searchFlightNumbers}
                                valueKey='value'
                                textField='label'
                                selectValue={flightValue}
                                onValueChange={(event) => { handleSelectChange(event, 'flightValue') }} />
                             {componentErrorMessages.flightValue && <FormText color="danger"> {componentErrorMessages.flightValue}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-4 "}>
                            <Label>Departure</Label>
                            <SelectListComponent
                                data={depAirports}
                                valueKey='value'
                                textField='label'
                                selectValue={depValue}
                                onValueChange={(event) => { handleSelectChange(event, 'depValue') }} />
                            {componentErrorMessages.depValue && <FormText color="danger"> {componentErrorMessages.depValue}</FormText>}
                        </FormGroup>
                    </Col>

                </Row>
                <Row>
                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-4 "}>
                            <Label>Destination</Label>
                            <SelectListComponent
                                data={desAirports}
                                valueKey='value'
                                textField='label'
                                selectValue={desValue}
                                onValueChange={(event) => { handleSelectChange(event, 'desValue') }} />
                            {componentErrorMessages.desValue && <FormText color="danger"> {componentErrorMessages.desValue}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="3">
                        <FormGroup className="mb-4">
                            <Label>Ticket Number</Label>
                            <SelectListComponent
                                data={tickets}
                                valueKey='value'
                                textField='label'
                                selectValue={ticketValue}
                                onValueChange={(event) => { handleSelectChange(event, 'ticketValue') }} />
                        </FormGroup>
                    </Col>

                    <Col xs="6" sm="3">
                        <FormGroup className="mb-4">
                            <Label>Status</Label>
                            <SelectListComponent
                                data={status}
                                valueKey='value'
                                textField='label'
                                selectValue={statusValue}
                                onValueChange={(event) => { handleSelectChange(event, 'statusValue') }} />
                        </FormGroup>
                    </Col>

                    <Col xs="6" sm="1">
                        <label>&nbsp;</label>
                        <Button className="btn-avi-primary" onClick={() => onSearch(1)}>Search</Button>
                    </Col>
                </Row>
            </Container>

        </Form>
    )
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/dispute-log/dispute-panel.js